import L from 'leaflet';
import 'leaflet-draw';
/**
 * Creates the drawing controls for the given feature group.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.drawnItems - The feature group where the geometry layers will be.
 * @returns {object} The draw controls for the feature group. Full and edition mode.
 */
const createGeometryDrawControlsMaps = ({ drawnItems }) => {
  const drawControlFull = new L.Control.Draw({
    edit: {
      featureGroup: drawnItems,
      poly: { allowIntersection: false }
    },
    draw: {
      polygon: true,
      marker: false,
      circle: false,
      polyline: true,
      rectangle: true,
      circlemarker: false
    }
  });

  const drawControlEdit = new L.Control.Draw({
    edit: {
      featureGroup: drawnItems,
      poly: { allowIntersection: false }
    },
    draw: {
      polygon: true,
      marker: false,
      circle: false,
      polyline: true,
      rectangle: true,
      circlemarker: false
    }
  });
  return { drawControlFull, drawControlEdit };
};

export default createGeometryDrawControlsMaps;
